import { render } from "./WhyChooseUsLanguageDropdown.vue?vue&type=template&id=0eb04a8b&scoped=true"
import script from "./WhyChooseUsLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./WhyChooseUsLanguageDropdown.vue?vue&type=script&lang=js"

import "./WhyChooseUsLanguageDropdown.vue?vue&type=style&index=0&id=0eb04a8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb04a8b"],['__file',"resources/js/components/WhyChooseUsLanguageDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0eb04a8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0eb04a8b', __exports__)) {
    api.reload('0eb04a8b', __exports__)
  }
  
  module.hot.accept("./WhyChooseUsLanguageDropdown.vue?vue&type=template&id=0eb04a8b&scoped=true", () => {
    api.rerender('0eb04a8b', render)
  })

}


export default __exports__